import template from './index.html'
import controller from './controller'

PartDetail.vsName = 'partDetail'
PartDetail.vsNgType = 'directive'

PartDetail.$inject = []
function PartDetail() {
  return {
    restrict: 'E',
    controller: controller,
    controllerAs: 'ctrl',
    bindToController: {
      part: '='
    },
    templateUrl: template,
  }
}

export default PartDetail